import { useRouter } from "../lib/router.js";
import { EmptyState } from "../components/ui.js";

export function NotFoundPage() {
  const { navigate } = useRouter();
  return (
    <div>
      <div className="page-header">
        <h1>Not found</h1>
      </div>
      <EmptyState title="This page doesn’t exist">
        The page you were looking for isn’t here.
        <br />
        <button className="btn btn-sm mt-4" onClick={() => navigate("/today")}>
          Back to Today
        </button>
      </EmptyState>
    </div>
  );
}
